import { beads, Bead } from '../beads.js';
import { settings } from '../settings.js';
import { mirror } from '../tools/mirror.js';

const applyMedallion = () => {
    let centerX = 1100;
    let centerY = 1100;
    beads.arr[0].x = centerX;
    beads.arr[0].y = centerY;
    beads.arr[0].circleAddress = {r: 0, i: 0};

    let counter = 1;

    let addCircle = (radius, number) => {
        for (let i = 0; i < number; i++) {
            let x = centerX + (radius * 38 * Math.sin(i * 2 * Math.PI / number));
            let y = centerY + (radius * 38 * Math.cos(i * 2 * Math.PI / number));
            beads.arr[counter].x = x;
            beads.arr[counter].y = y;
            beads.arr[counter].circleAddress = {
                r: radius,
                i: i
            };
            beads.arr[counter].angle = 90 - (i * 360 / number);
            counter++;
        }
    };

    for (let i = 1; i < settings.rows; i++) {
        addCircle(i, i * 8);
    }

    beads.arr.forEach((_bead, i) => {
        if (i > counter) {
            _bead.ignore = true;
            _bead.circleAddress = {r: null, i: null};
        }
    });
};

export const medallionConfig = {
    name: 'medallion',
    displayName: 'Medallion',
    canSelectCommute: false,
    canSelectDirection: false,
    canSelectStartingBead: false,
    canSelectPanelWidth: false,
    canExportSmallDiagrams: false,
    noChangePattern: true,
    plastic: false,
    noCustomBeadSize: true,
    simpleExport: true,
    noDrag: true,
    noGuides: true,
    beadFromPoint: true,
    noColumns: true,
    rowLimit: 23,
    create: () => {
        let n = settings.rows;
        let beadsNeeded = 4 * n * (n - 1) + 1;
        for (let i = 0; i < beadsNeeded; i++) {
            let j = Math.floor(i / 10);
            beads.arr.push(new Bead(j, i));
        }
    },
    colDist: () => 50,
    rowDist: () => 50,
    offset: () => 0,
    startScroll: [420, 686],
    offsetPattern: [0],
    apply: null,
    getDimensions: (myRows, myColumns, diameter, beadLength) => {
        return {
            width: myRows * beadLength * 0.242, // to implement
            height: myRows * beadLength * 0.242
        };
    },
    getExportImageDimensions: rows => {
        const max = Math.max(rows, 15);
        return {
            width: 2000 * (max/23),
            height: 2000 * (max/23)
        }
    },
    getBeadingModeStartingPosition: ({bead}) => [bead.circleAddress.r, 1],
    newProject() {
        applyMedallion()
    },
    disabledTools: ['Row Shift', 'Paint', 'Star'],
    getRowsAndColumns: ({rows, columns, size}) => {
        rows = size;
        columns = 0; // not used
        return [rows, columns];
    },
    useSingleRenderTexture: true,
    getCoordinates(bead) {
        const row = bead.circleAddress.r;
        const column = bead.circleAddress.i;
        return [row, column];
    },
    manualFindBead: true,
    specialMirror: true,
    startMirror: () => {
        beads.mirror.forEach(mirror => {
            mirror.setX(beads.arr[0].x);
            mirror.setY(beads.arr[0].y);
        });
        beads.mirror.active = true;
    },
    findMirrorBead: mirror.findMedallionMirrorBead,
    getRTLocation: () => {
        const x = 600 - (settings.rows * 16);
        const y = 600 - (settings.rows * 16);
        return [x, y];
    },
    specialWordChartKey: 'getMedallionWordChart',
    doBeadingKey: 'medallion',
    rotateMirror: mirror.rotateMedallionMirror,
    arrangeGrid: false
};